var Print = {};

Print.init = function() {
	window.print();
};

export default Print;